import { BadgeEuro, Scale, ShieldCheck } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "TÜV-zertifiziert", sub: "TÜV Rheinland / FSP-Partner" },
  { icon: Scale, label: "Unabhängig", sub: "werkstatt- & versicherungsfrei" },
  { icon: BadgeEuro, label: "Kostenlos", sub: "bei unverschuldetem Unfall" },
];

export const TrustBadges = () => (
  <ul className="mt-8 grid gap-3 sm:grid-cols-3" data-testid="hero-trust-badges">
    {BADGES.map(({ icon: Icon, label, sub }) => (
      <li key={label} className="flex items-center gap-3 rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur-md">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-brand-yellow text-brand-anthracite">
          <Icon className="h-5 w-5" strokeWidth={2} />
        </span>
        <span className="leading-tight">
          <span className="block text-[15px] font-bold text-white">{label}</span>
          <span className="block text-xs text-white/80">{sub}</span>
        </span>
      </li>
    ))}
  </ul>
);
